import styled from 'styled-components';

// Components
import { Typography } from '../../display/Typography';

export const DoubleColumnContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.xxxl}rem 10rem;
  flex-wrap: wrap;
  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;

export const ContainerDescription = styled.div`
  width: 100%;
  max-width: 96.9rem;
  min-width: 71rem;
  flex: 1;

  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    max-width: 100%;
    min-width: 0;
  }
`;

export const ContainerOT = styled.div`
  width: 100%;
  max-width: 77.6rem;
  flex: 1;
  > div {
    gap: ${({ theme }) => theme.spaces.xl}rem;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    max-width: 90rem;
    > div {
      gap: ${({ theme }) => theme.spaces.l}rem;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    max-width: initial;
  }
`;

export const ErrorMessage = styled(Typography)`
  margin-top: ${({ theme }) => theme.spaces.xxs}rem;
`;

export const ContainerWithButton = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.l}rem;
`;
